<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M2.01313 12.0122C2.01313 14.7184 4.12548 16.9102 6.7196 16.9102V18.1347C3.44607 18.1347 0.777832 15.3918 0.777832 12.0122C0.777832 8.63265 3.44607 5.8898 6.7196 5.8898H11.9449L9.90666 3.86939L10.7837 3L14.3043 6.4898L10.7837 9.97959L9.90666 9.1102L11.9449 7.0898H6.7196C4.12548 7.0898 2.01313 9.28163 2.01313 11.9878V12.0122ZM15.8361 5.8898V7.11429C18.4302 7.11429 20.5425 9.30612 20.5425 12.0122C20.5425 14.7184 18.4302 16.9102 15.8361 16.9102H10.6108L12.649 14.8898L11.7719 14.0204L8.25136 17.5102L11.7719 21L12.649 20.1306L10.6108 18.1102H15.8361C19.1096 18.1102 21.7778 15.3673 21.7778 11.9878C21.7778 8.60816 19.1096 5.86531 15.8361 5.86531V5.8898Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
